import React from "react";
import Markdown from "markdown-to-jsx";

const elements = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",

  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan",
];

const allowedElements = ["a", "b", "strong", "em", "u", "code", "del"];

const CustomLink = ({ children, ...props }) => (
  <a {...props} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);

const MarkdownWrapper = ({ children }) => {
  const boldRegex = /\*(.*?)\*/g;
  const tildaRegex = /~(.*?)~/g;
  // Itálico WA: só quando _texto_ está delimitado por espaço/pontuação (não senhas tipo Cr2@Ez_DEinP_q)
  const waItalicRegex = /(^|[\s(])_([^_\n]+)_($|[\s).,!?:;])/g;

  const pixMarker = "###PIX_MARKER###";

  if (children && children.includes("***")) {
    children = children.replace(/\*\*\*/g, pixMarker);
  }

  if (children && boldRegex.test(children)) {
    children = children.replace(boldRegex, "**$1**");
  }

  if (children && children.includes(pixMarker)) {
    children = children.replace(new RegExp(pixMarker, "g"), "***");
  }

  if (children && tildaRegex.test(children)) {
    children = children.replace(tildaRegex, "~~$1~~");
  }

  if (children) {
    const italicToken = "\uE000";
    const italics = [];
    children = children.replace(waItalicRegex, (match, before, inner, after) => {
      italics.push(inner);
      return `${before}${italicToken}${italics.length - 1}${italicToken}${after}`;
    });

    // Preserva URLs intactas antes do escape generico de underscore
    // (senao o "\_" inserido quebra a exibicao/clicabilidade do link).
    const urlToken = "\uE001";
    const urls = [];
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    children = children.replace(urlRegex, (match) => {
      urls.push(match);
      return `${urlToken}${urls.length - 1}${urlToken}`;
    });

    children = children.replace(/_/g, "\\_");
    children = children.replace(/\uE000(\d+)\uE000/g, (_, index) => `_${italics[Number(index)]}_`);
    children = children.replace(/\uE001(\d+)\uE001/g, (_, index) => urls[Number(index)]);
  }
  const options = React.useMemo(() => {
    const markdownOptions = {
      disableParsingRawHTML: true,
      forceInline: true,
      overrides: {
        a: { component: CustomLink },
      },
    };

    elements.forEach((element) => {
      if (!allowedElements.includes(element)) {
        markdownOptions.overrides[element] = (el) => el.children || null;
      }
    });

    return markdownOptions;
  }, []);

  if (!children) return null;

  return <Markdown options={options}>{children}</Markdown>;
};

export default MarkdownWrapper;
